import { SelectOption } from "./types";

export const EXCLUDE_INTERNAL_SESSIONS_FILTER = {
    _or: [{ is_team_internal_session: { _null: true } }, { is_team_internal_session: { _eq: false } }],
};

export const CLIENT_TYPE_OPTIONS: Array<SelectOption> = [
    { value: "maiores_18", label: "Maiores 18" },
    { value: "menores_igual_18", label: "Menores ou igual 18" },
];

// Réplica da fórmula Zoho if(age_when_started > 18, 'Maiores 18', 'Menores ou igual 18'):
// tratamentos sem idade registada caem em "Menores ou igual 18" (validado: 1002 vs 2183+1800 nulos).
export const sessionClientTypeFilterByOption: Record<string, any> = {
    maiores_18: { treatment: { age_when_started: { _gt: 18 } } },
    menores_igual_18: {
        treatment: { _or: [{ age_when_started: { _lte: 18 } }, { age_when_started: { _null: true } }] },
    },
};

export const treatmentClientTypeFilterByOption: Record<string, any> = {
    maiores_18: { age_when_started: { _gt: 18 } },
    menores_igual_18: { _or: [{ age_when_started: { _lte: 18 } }, { age_when_started: { _null: true } }] },
};

export const treatmentMatchesClientType = (ageWhenStarted: number | null | undefined, clientTypeOption: string | null) => {
    if (clientTypeOption === null) return true;
    if (clientTypeOption === "maiores_18") return ageWhenStarted !== null && ageWhenStarted !== undefined && ageWhenStarted > 18;
    const isMenores = ageWhenStarted === null || ageWhenStarted === undefined || ageWhenStarted <= 18;
    return isMenores;
};
